<template>
  <div class="videoContainerScreen">
    <div class="overlay">
      <span class="vert-move" @click="sendAnchor('.introduction')">
        <font-awesome-icon :icon="['fas', 'chevron-down']" size="2x" :style="{ color: 'white' }" />
      </span>
    </div>
    <span class="text">
      LEVERAGE us, Value you
      <b-button
        variant="primary"
        class="readMoreButton"
        @click="sendAnchor('.introduction')"
      >{{$t("videoContainer.readMore")}}</b-button>
    </span>
    <video id="videobanScreen" class="theVideo" preload="none" autoplay muted loop playsinline>
      <!-- <source src="/frontImages/test.mov" /> -->
      <source src="/frontImages/test.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  methods: {
    sendAnchor(anchorName) {
      document.querySelector(anchorName).scrollIntoView({ behavior: "smooth" });

      setTimeout(() => {
        window.scrollBy(0, -100);
      }, 500);
    }
  }
};
</script>

<style scoped>
.theVideo{
    filter: opacity(59%) grayscale(40%);;
    width:100%;
}

.videoContainerScreen {
  height: 100vh;
  object-fit: cover;
  width: 100%;
  background-color: black;
  position: relative;
}

#videobanScreen {
  height: 100vh;
  width: 100%;
  object-fit: cover;
  object-position: center center;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.25;
  display: flex;
  justify-content: center;
}

.text {
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 4rem;
  flex-direction: column;
}

.vert-move {
  position: absolute;
  bottom: 5rem;
}

span.vert-move {
  -webkit-animation: mover 0.75s infinite alternate;
  animation: mover 0.75s infinite alternate;
}
span.vert-move {
  -webkit-animation: mover 0.75s infinite alternate;
  animation: mover 0.75s infinite alternate;
}
@-webkit-keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-25px);
  }
}
@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-25px);
  }
}

.readMoreButton {
  z-index: 99;
}
</style>